var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"mx-3"},[_vm._v(" "+_vm._s(_vm.mdiArrowRight)+" ")]),_vm._v(" "+_vm._s(_vm.title)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }